<template>
  <main>
    <div v-if="showStartUpPlan" id="loading" class="text-center">
      <loading></loading>
    </div>
    <b-row style="background: #fffbfe" v-if="!showStartUpPlan">
      <b-col>
        <stepper :steps="steps" :isSummaryPage="true"></stepper>
      </b-col>
    </b-row>
  </main>
</template>

<script>
  import Stepper from '../../start-up-plan/Stepper.vue';
  export default {
    components: {
      Stepper,
    },
    props: {
      milestones: Array,
      standardSteps: Array,
      milestonesTitleMap: Object,
    },
    data() {
      return {
        studyId: '',
        siteId: '',
        showStartUpPlan: false,
        tempArray: [],
        steps: [],
      };
    },
    computed: {},
    watch: {
      $route() {
        this.initialize();
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        this.showStartUpPlan = false;
        this.tempArray.splice(0, this.tempArray.length);
        this.steps.splice(0, this.steps.length);
        this.steps = _.cloneDeep(this.standardSteps);
        this.studyId = this.$route.params['studyId'];
        this.siteId = this.$route.params['siteId'];
        this.calcSteps();
        this.calcStatuses();
        this.$emit('calculatedSteps', this.steps);
      },
      calcSteps() {
        this.steps.forEach(step => {
          let milestone = this.milestones.find(
            el => this.milestonesTitleMap[el['milestoneName']] === step['title'],
          );
          if (milestone) {
            step['plannedDate'] = milestone['plannedDate'];
            step['actualDate'] = milestone['actualDate'];
          }
        });
      },
      calcStatuses() {
        this.steps.forEach(el => {
          if (el['subSteps'].length > 0) {
            el['subSteps'].forEach(x => {
              this.tempArray.push(_.cloneDeep(x));
            });
          }
          this.tempArray.push(_.cloneDeep(el));
        });
        this.statuses();
        this.steps.splice(0, this.steps.length);
        this.returnToInitStepsArray(this.tempArray);
      },
      statuses() {
        let lastStatus = 'Untouched';
        let keepLastStepIndex;
        this.tempArray
          .slice()
          .reverse()
          .forEach((step, index) => {
            if (lastStatus === 'Untouched') {
              step['status'] = step['actualDate'] ? 'Completed' : 'Untouched';
              if (step['status'] === 'Completed') {
                keepLastStepIndex = this.tempArray.length - index;
              }
            }
            if (lastStatus === 'Completed') {
              step['status'] = 'Completed';
            }
            lastStatus = step['status'];
          });

        if (keepLastStepIndex < this.tempArray.length) {
          this.tempArray[keepLastStepIndex]['status'] = 'InProgress';
        }
      },
      returnToInitStepsArray() {
        this.tempArray.forEach(element => {
          if (!element['parentOrder']) {
            this.steps.push(element);
          }
        });
        this.tempArray.forEach(element => {
          if (element['parentOrder']) {
            let foundStepIndex = this.steps.findIndex(
              step => step['order'] === element['parentOrder'],
            );
            let foundSubStepIndex = this.steps[foundStepIndex]['subSteps'].findIndex(
              subStep => subStep['order'] === element['order'],
            );
            this.steps[foundStepIndex]['subSteps'][foundSubStepIndex] = element;
          }
        });
      },
    },
  };
</script>

<style></style>
